var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductAttributeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 480 c-26 -26 -25 -55 1 -81 15 -15 29 -20 49 -16 22 5 34 -1 64 -32 34 -35 37 -41 26 -61 -7 -13 -10 -38 -6 -61 5 -33 2 -40 -21 -58 -19 -16 -34 -20 -59 -15 -37 7 -74 -21 -74 -56 0 -26 34 -60 60 -60 30 0 63 38 57 66 -3 18 4 30 29 49 32 25 35 25 59 9 14 -9 37 -14 54 -12 24 3 32 0 40 -19 8 -17 8 -30 0 -45 -24 -45 17 -96 67 -84 58 15 53 101 -6 113 -43 8 -54 34 -32 72 21 39 37 39 56 2 24 -45 63 -54 96 -21 25 25 25 55 0 80 -25 25 -55 25 -80 0 -25 -25 -46 -17 -54 20 -3 16 -15 39 -26 50 -29 29 -25 48 15 64 57 24 57 98 1 112 -54 13 -93 -43 -62 -91 20 -30 11 -55 -21 -55 -13 0 -34 -5 -45 -11 -17 -9 -26 -5 -59 27 -31 30 -37 42 -32 64 4 20 -1 34 -16 49 -26 26 -55 27 -81 1z m70 -15 c15 -18 10 -45 -12 -59 -35 -22 -74 27 -48 59 16 19 44 19 60 0z m260 0 c26 -32 -13 -81 -47 -59 -23 14 -28 41 -13 59 16 19 44 19 60 0z m-45 -160 c33 -32 33 -78 0 -110 -49 -50 -135 -15 -135 55 0 19 9 40 25 55 15 16 36 25 55 25 19 0 40 -9 55 -25z m165 -70 c15 -18 10 -45 -12 -59 -35 -22 -74 27 -48 59 16 19 44 19 60 0z m-380 -110 c26 -32 -13 -81 -47 -59 -23 14 -28 41 -13 59 16 19 44 19 60 0z m290 -40 c15 -18 10 -45 -12 -59 -35 -22 -74 27 -48 59 16 19 44 19 60 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductAttributeIcon);
export default __webpack_public_path__ + "static/media/productAttributeIcon.153f133a6d0be2fdc5f84d2c37f3de21.svg";
export { ForwardRef as ReactComponent };